/*
 * return locale
 */
export default (path = window.location.pathname) => {
  return path === "/de" || path.indexOf("/de/") === 0 ? "de" : "en";
};
